var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMirror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dis"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2058",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white",
    stroke: "#29282F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medium",
    d: "M10.6625 12.275C10.6625 12.1 10.575 11.925 10.4875 11.8375L9.175 10.2625V10H13.2L16.35 16.9125L19.15 10H23V10.2625L21.8625 11.3125C21.775 11.4 21.6875 11.4875 21.775 11.6625V19.5375C21.775 19.625 21.775 19.8 21.8625 19.8875L22.9125 20.9375V21.2H17.4V20.9375L18.5375 19.8C18.625 19.7125 18.625 19.625 18.625 19.45V13.0625L15.475 21.025H15.125L11.45 13.0625V18.4C11.45 18.6625 11.5375 18.8375 11.625 19.0125L13.1125 20.7625V21.025H9V20.7625L10.4875 19.0125C10.6625 18.8375 10.75 18.6625 10.6625 18.4V12.275Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.c21607e1f5cf5a8d201cb9105e6c6739.svg";
export { ForwardRef as ReactComponent };